module.exports = __webpack_public_path__ + "img/comunidad.6dc3ea73.jpeg";